import { WhatsAppIcon } from "./Icons";

export default function FloatingButtons() {
  const displayNumber = "+92 323-5159616";
  const waNumber = "923235159616";

  return (
    <div className="float-btns" aria-label="Floating WhatsApp button">
      <a
        href={`https://wa.me/${waNumber}`}
        target="_blank"
        rel="noopener noreferrer"
        className="float-whatsapp"
        aria-label="WhatsApp"
        title="WhatsApp"
      >
        <span className="float-whatsapp__icon" aria-hidden="true">
          <WhatsAppIcon size={20} />
        </span>
        <span className="float-whatsapp__label">{displayNumber}</span>
      </a>
    </div>
  );
}
